
import { Options, Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import html2canvas from "html2canvas";
import { ElMessage } from "element-plus";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import {
  dispatchGetPerformancePageListSummary,
  dispatchGetPerformanceSelectOptions,
  dispatchDeepNzmSimpleRetry,
  dispatchDeepPerformancSummaryEdit,
} from "@/store/performance/actions";
import {
  dispatchGetProjectScenes,
  dispatchGetProjectDetail,
} from "@/store/project/actions";
import {
  readDeepPerformanceSelectOptions,
  readDeepPerformanceSelectOptionsOld,
  readDeepPerformanceSelectOptionsLast,
  readStressPerfReport,
  readPerformancePageListSummary,
} from "@/store/performance/getters";
import { store } from "@/store";
import {
  readMyProjects,
  readProjectScenes,
  readProjectDetail,
} from "@/store/project/getters";
import {
  readPerfDashboard,
  readPerformancePageList,
  readPerformanceSelectOptions,
} from "@/store/performance/getters";
import { readDeviceSpecs } from "@/store/device/getters";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";

import { read } from "xlsx";
import { ref } from "vue";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
export default class TestReport extends Vue {
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public edit(data) {
    data.flag = !data.flag;
  }
  public ruleForm = {
    report_type: "",
    sub_type: "",
  };
  public downloadFile(url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // 可以设置下载文件的名称，留空则使用原文件名
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  public edit_input(data) {
    // console.log(data.remark);
    data.flag = !data.flag;
    dispatchDeepPerformancSummaryEdit(store, {
      id: data.id,
      project: this.localProject,
      remark: data.remark,
      is_valid: data.is_valid,
    });
  }
  public get subList() {
    let list = [];
    if (this.ruleForm.report_type == "13") {
      list = [
        { name: "局内", value: "0" },
        { name: "局外", value: "1" },
      ];
    } else if (this.ruleForm.report_type == "9") {
      list = [
        { name: "Default", value: "0" },
        { name: "开profile", value: "1" },
        { name: "关profile", value: "2" },
      ];
    } else {
      list = [{ name: "Default", value: "0" }];
    }
    return list;
  }
  public flag = true;
  public formatDate(dateStr) {
    const date = new Date(dateStr);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  public get report_type() {
    let list = [];
    let falseArray: any = [36, 34, 40, 47, 12, 32, 4];
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 32) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 36) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤测试报告", value: 5 },
        { name: "UI性能测试报告", value: 25 },
      ];
    }
    if (this.localProject === 4) {
      list = [
        { name: "Default", value: 0 },
        { name: "分支性能", value: 21 },
        { name: "主干性能", value: 22 },
        { name: "分支dev", value: 23 },
        { name: "主干dev", value: 24 },
        { name: "登录测试", value: 30 },
        { name: "iOS登录", value: 41 },
      ];
    }
    if (this.localProject === 12) {
      list = [{ name: "Default", value: 0 }];
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
    }

    return list;
  }
  public get projectDetail() {
    return readProjectDetail(store);
  }
  public titleWidth(type) {
    if (type == "GameThread") {
      return 110;
    }
    if (type == "UnityMain") {
      return 110;
    }
    if (type == "RenderThread") {
      return 130;
    }
    if (type == "AppCPU(%)") {
      return 110;
    }
    if (type == "TotalCPU(%)") {
      return 110;
    }
    if (type == "CPU Freq(MHz)") {
      return 130;
    }
    if (type == "Peak Memory(MB)") {
      return 200;
    }
    if (type == "带宽读(MB/s)") {
      return 110;
    }
    if (type == "带宽写(MB/s)") {
      return 110;
    }
    if (type == "UnityGfxDeviceW") {
      return 200;
    }
    if (type == "NativeThread") {
      return 130;
    }
    if (type == "UnityGfx") {
      return 110;
    }
    if (type == "RHIThread") {
      return 100;
    }
    if (type == "RenderThread 3") {
      return 130;
    }
  }
  public async mounted() {
    // let list=['v_yihuideng','pagezhang','v_baofeiyan']
    //  dispatchGetProjectDetail(store, {
    //   id: this.localProject,
    //   project: this.localProject,
    // });

    dispatchGetDeviceSpecs(store, { project: this.localProject });
    // dispatchGetSimpleScripts(store, { project: this.localProject });
    dispatchGetPerformancePageListSummary(store, {
      project: this.localProject,
      date: "",
      task_record_id: "",
      scene_id_list: [],
      device_id_list: [],
      game_versions: [],
      page: 1,
      size: this.record,
      is_valid: 1,
      is_deep: "",
      type: "",
      subtype: "",
    });

    await dispatchGetProjectScenes(store, { project: this.localProject });
    // if(JSON.stringify(this.projectDetail)!='{}'){
    //   console.log(this.projectDetail)
    // }
    // setInterval(()=>{
    //    console.log(this.projectDetail)
    // },1000)

    // 下拉框
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
  }
  public retry(num) {
    dispatchDeepNzmSimpleRetry(store, {
      id: num,
      project: this.localProject,
    });
  }
  public async onTableClear() {
    this.loading = true;
    this.selected_table_scene = [];
    this.selected_table_device = [];
    this.selected_table_version = [];
    this.selected_table_date = "";
    this.selected_table_judge = "";
    this.indexValue = "";
    this.ruleForm.report_type = "";
    this.ruleForm.sub_type = "";
    this.record = 16;
    this.deep_type = "";
    this.deep_check = false;
    await dispatchGetPerformancePageListSummary(store, {
      project: this.localProject,
      date: "",
      task_record_id: "",
      scene_id_list: [],
      device_id_list: [],
      game_versions: [],
      page: 1,
      size: this.record,
      is_valid: 1,
      is_deep: "",
      type: "",
      subtype: "",
    });

    this.loading = false;
  }

  public get subType() {
    let list = [];

    list = [
      {
        label: "Threads(ms)",
        sub: [
          { lable: "UnityMain", value: "UnityMain" },
          { lable: "CoreThread", value: "CoreThread" },
          { lable: "UnityGfx", value: "UnityGfx" },
        ],
      },
      {
        label: "CPU",
        sub: [
          { lable: "AppCPU(%)", value: "avg_cpu" },
          { lable: "TotalCPU(%)", value: "avg_cpu_total" },
          { lable: "CPU Freq(MHz)", value: "avg_cpu_freq" },
        ],
      },
      {
        label: "GPU",
        sub: [
          { lable: "GPU(%)", value: "gpu_usage" },
          { lable: "带宽读(MB/s)", value: "BandwidthRead" },
          { lable: "带宽写(MB/s)", value: "BandwidthWrite" },
        ],
      },
    ];
    if (this.localProject == 7) {
      list[0].sub = [
        { lable: "UnityMain", value: "UnityMain" },
        { lable: "UnityGfxDeviceW", value: "UnityGfxDeviceW" },
        { lable: "NativeThread", value: "NativeThread" },
      ];
    }
    if (this.localProject == 4) {
      list[0].sub = [
        { lable: "UnityMain", value: "UnityMain" },
        { lable: "UnityGfxDeviceW", value: "UnityGfxDeviceW" },
        { lable: "Worker Thread", value: "Worker Thread" },
      ];
    }
    if (this.localProject == 34) {
      list[0].sub = [
        { lable: "UnityMain", value: "UnityMain" },
        { lable: "CoreThread", value: "CoreThread" },
        { lable: "UnityGfx", value: "UnityGfx" },
      ];
    }
    if (this.localProject == 48) {
      list[0].sub = [
        { lable: "GameThread", value: "GameThread" },
        { lable: "RHIThread", value: "RHIThread" },
        { lable: "RenderThread 3", value: "RenderThread 3" },
      ];
    }

    if (
      this.localProject !== 7 &&
      this.localProject !== 34 &&
      this.localProject !== 4 &&
      this.localProject !== 48
    ) {
      if (this.projectDetail.engine === "Unity") {
        list[0].sub = [
          { lable: "UnityMain", value: "UnityMain" },
          { lable: "UnityGfx", value: "UnityGfx" },
          { lable: "NativeThread", value: "NativeThread" },
        ];
      } else {
        list[0].sub = [
          { lable: "GameThread", value: "GameThread" },
          { lable: "RenderThread", value: "RenderThread" },
        ];
      }
    }
    return list;
  }
  public see(data) {
    const { href } = this.$router.resolve({
      path: "/deep_performance_analysis",
      // path: "/testdmo",
      query: {
        ...this.$route.query,
        auto: data.is_auto ? 2 : 0,
        type: data.type,
        subtype: this.query_sub(data.type, data.subtype),
        scene_id: data.scene_id.id,
        device_id: data.device_id.id,
        flame_thread: this.subType[0].sub.map((v) => v.value).join(","),
        id_test: data.id_test,
      },
    });
    window.open(href, "_blank");
    return Promise.resolve(true); // 不刷新表格
  }
  public get dataProcessing() {
    this.sumMary_data.results.forEach((item: any) => {
      if (item.tester === null) {
        item.tester = item.task_record_id?.create_user;
      }
      item.RecordID = item.task_record_id;
      for (let i in item) {
        if (item[i] === "" || item[i] === null || item[i] === undefined) {
          item[i] = "--";
        }
      }
      if (item.task_record_id !== "--") {
        item.RecordID = item.task_record_id.id;
      }
    });

    return this.sumMary_data.results;
  }
  public get sumMary_data() {
    let list = readPerformancePageListSummary(store);
    list.results.forEach((v) => {
      (v as any).flag = true;
    });
    return list;
  }
  public indexMethod(index: any) {
    return index + 1 + (this.current_page - 1) * this.record;
  }
  public record = 16; //记录条数
  // 场景
  public selected_table_date = "";
  public selected_table_scene = [];
  // 设备
  public selected_table_device = [];
  // 版本
  public selected_table_version = [];
  // 是否有效
  public selected_table_judge = "";
  // record_id
  public mergeItemsByLabel(items) {
    const mergedItems = [];

    for (const item of items) {
      const existingItem = mergedItems.find(
        (mergedItem) => mergedItem.label === item.label
      );

      if (existingItem) {
        existingItem.value.push(item.value);
      } else {
        mergedItems.push({
          label: item.label,
          value: [item.value],
          level: item.level,
        });
      }
    }

    return mergedItems;
  }
  public deep_type = "";
  public deep_check = false;
  public indexValue = "";
  public localProject = Number(getLocalProject());
  public get getScenes() {
    const scenes = readProjectScenes(store);
    return scenes;
  }
  public async deepBtn(operation) {
    this.deep_check = !this.deep_check;
    if (this.deep_check) {
      this.deep_type = "primary";
    } else {
      this.deep_type = "";
    }
    let device_id: any = [] || "";
    this.device_options.forEach((v) => {
      v.data.forEach((item, index) => {
        if (item.label == this.selected_table_device) {
          device_id = item.value;
        }
      });
    });
    await dispatchGetPerformancePageListSummary(store, {
      project: this.localProject,
      date: this.selected_table_date,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: device_id,
      game_versions: this.selected_table_version,
      page: operation === "Search" ? 1 : this.current_page,
      size: this.record,
      is_valid: 1,
      is_deep: this.deep_check ? 1 : "",
      type: this.ruleForm.report_type,
      subtype: this.ruleForm.sub_type,
    });
  }
  public get performace_select_options() {
    const options = readPerformanceSelectOptions(store);
    return options;
  }
  public get judge() {
    let list = [
      { label: "有效", value: 1 },
      { label: "无效", value: 0 },
    ];
    return list;
  }
  public statusShow(item) {
    let list = [
      "",
      "上传中",
      "入库中",
      "处理中",
      "失败",
      "正常",
      "上传CPU数据",
    ];
    let text = list[item];
    let colorList = ["orange", "red", "green"];
    let color = "";
    let flag = false;
    if (item < 4) {
      color = colorList[0];
      flag = false;
    }
    if (item === 4) {
      color = colorList[1];
      flag = false;
    }
    if (item == 5) {
      color = colorList[2];
      flag = true;
    }
    if (item == 6) {
      color = colorList[0];
      flag = false;
    }
    return [text, color, flag];
  }
  public get date_options() {
    return this.performace_select_options.date_list;
  }
  public query_type(data) {
    if (this.test_type.findIndex((v) => v == data)) {
      return this.in_list.find((v) => v == data);
    } else {
      return "";
    }
  }
  public query_sub(data, sub) {
    if (data == 9) {
      return sub;
    } else {
      return 0;
    }
  }
  public in_list = [3, 4, 9];
  public test_type = [
    "Default",
    "QQ飞车测试",
    "分组标签报告",
    "局外皮肤测试",
    "局内皮肤测试",
    "炽热局内皮肤测试",
    "label标签报告",
    "热力图报告",
    "极限测试",
    "5V5真人测试",
    "逆战标签报告",
    "5V5真人测试New",
    "皮肤管线",
    "GPU Counter",
    "QQ飞车GPU报告",
    "逆战GPU报告",
    "SimplePerf",
    "SimplePerf",
    "自动化内存测试",
    "分支性能",
    "主干性能",
    "分支dev",
    "主干dev",
    "Unity内存",
    "UI控件性能",
    "CPU性能测试",
    "跑图性能测试",
    "PVE性能测试",
    "包体资源",
    "登录测试",
  ];
  public test_sub_type = ["Default", "开profile", "关profile", "局外", "局内"];
  public get scene_options() {
    const scene_list: any[] = this.performace_select_options.scene_list;
    scene_list.forEach((scene) => {
      let chinese = this.getScenes.filter(
        (item: any) => item.id === Number(scene.scene_id)
      )[0]?.chinese;
      scene.chinese = chinese;
    });

    return scene_list.sort((a, b) => a.chinese?.localeCompare(b.chinese));
  }
  public get getDeviceSpecs() {
    return readDeviceSpecs(store);
  }
  public current_page = 1;
  public loading = false;
  public async selectTableChange(operation: any, item) {
    if (item) {
      this.ruleForm.sub_type = "";
    }
    this.loading = true;
    let device_id: any = [] || "";
    this.device_options.forEach((v) => {
      v.data.forEach((item, index) => {
        if (item.label == this.selected_table_device) {
          device_id = item.value;
        }
      });
    });
    await dispatchGetPerformancePageListSummary(store, {
      project: this.localProject,
      date: this.selected_table_date,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: device_id,
      game_versions: this.selected_table_version,
      page: operation === "Search" ? 1 : this.current_page,
      size: this.record,
      is_valid: 1,
      is_deep: this.deep_check ? 1 : "",
      type: this.ruleForm.report_type,
      subtype: this.ruleForm.sub_type,
    });

    // await this.dataProcessing;
    this.loading = false;
  }
  public get game_version_options() {
    const versions = this.performace_select_options.game_versions;
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return unique_json(game_version_select, "value");
  }
  public get device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];

    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });

    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < this.mergeItemsByLabel(device_select).length; i++) {
      let ai = this.mergeItemsByLabel(device_select)[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }

    return dest.sort(compare("level"));
  }
}
